import { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

const DropdownMenu = ({ children, refreshing = false }) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);

  }, [isOpen]);

  return (
    <div className='dropdown position-relative' ref={menuRef} data-testid='dropdown-menu'>
      <button className='btn btn-link p-2 ellipsis-menu' type='button' aria-haspopup='true' aria-expanded={isOpen} onClick={setIsOpen} data-testid="toggle-button">
        {refreshing && (
          <output className='spinner-border spinner-border-sm mr-2' aria-live='polite'>
            <span className='sr-only'>Loading...</span>
          </output>
        )}
        <FontAwesomeIcon icon={faEllipsisV} />
      </button>
      {isOpen && <div className='dropdown-menu dropdown-menu-right show shadow-sm min-rem-15' onClick={() => setIsOpen(false)} data-testid="menu-container">{children}</div>}
    </div>
  );
};

export default DropdownMenu;